import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { consumeUrlLoginToken } from "../utils/urlLoginToken";

export default function UrlLoginTokenHandler() {
  const history = useHistory();
  const location = useLocation();
  useEffect(() => {
    consumeUrlLoginToken({
      location,
      replace: (url) => history.replace(url, location.state),
    });
  }, [history, location]);
  return null;
}
